<template>
  <p class="mb-8">Organize e acompanhe as atividades da sua clínica com clareza, atribuição de
    responsáveis, controle de prazos e status em tempo real.</p>

  <!-- <v-btn variant="outlined" size="large" color="white" @click="handleCreateAccount">Solicitar Acesso</v-btn> -->
</template>
